module.exports = "/images/FazeRug_36700b.jpg";